import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["href", "title", "description", "role", "onClick", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './NavItem.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var NavItemBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var href = _ref.href,
      title = _ref.title,
      description = _ref.description,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? "menuitem" : _ref$role,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsxs(views.Wrapper, _objectSpread(_objectSpread({
    role: role,
    href: href,
    onClick: onClick
  }, rest), {}, {
    ref: ref,
    children: [_jsx(views.Title, _objectSpread(_objectSpread({
      variant: "buttonSmall"
    }, tokens.title), {}, {
      children: title
    })), _jsx(views.Description, _objectSpread(_objectSpread({
      variant: "textRegularSmall"
    }, tokens.description), {}, {
      children: description
    }))]
  }));
});
var NavItem = withDesignTokens(NavItemBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      title: {
        color: theme.palette.twilio.gray[100]
      },
      description: {
        color: theme.palette.twilio.gray[60]
      }
    };
  },
  light: function light(theme) {
    return {
      title: {
        color: theme.palette.brand.darkAcai[900]
      },
      description: {
        color: theme.palette.brand.darkAcai[400]
      }
    };
  },
  dark: function dark(theme) {
    return {
      title: {
        color: theme.palette.brand.darkAcai[900]
      },
      description: {
        color: theme.palette.brand.darkAcai[400]
      }
    };
  }
});
export default NavItem;